import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import bagIcon from "../assets/shopping-bag.svg";

const CartButton = (props: any) => {
  const { className, itemCount } = props;
  return (
    <Link to="/cart">
      <Wrapper className={className}>
        <span className={"item-count"}>{itemCount ? itemCount : ""}</span>
        <img src={bagIcon} alt="bag-icon" />
      </Wrapper>
    </Link>
  );
};

const Wrapper = styled.div`
  color: #979797;
  position: relative;

  .item-count {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 50%);
    font-family: HelveticaNeue-Bold;
    font-size: 17px;
    color: #73787e;
  }
  img {
    width: 34px;
    filter: invert(61%) sepia(0%) saturate(0%) hue-rotate(238deg)
      brightness(98%) contrast(97%);
  }
`;

export default CartButton;
